var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6416 5.9623L7.39635 1.20755C7.69824 0.905666 8.15107 0.679249 8.67938 0.679249C9.20768 0.679249 9.66052 0.905666 10.0379 1.20755C10.7926 1.96228 10.7926 3.16983 10.0379 3.84908L7.92466 5.9623H8.98127L10.4907 4.45286C11.5473 3.39625 11.5473 1.73586 10.4907 0.754722C9.9624 0.226416 9.28315 0 8.6039 0C7.92465 0 7.32088 0.150944 6.79257 0.679249L2.03783 5.50947C1.81141 5.66041 1.66047 5.88683 1.50952 6.18872C1.88688 6.03777 2.26424 5.9623 2.6416 5.9623Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50933 4.15088L3.698 5.96221H7.24519L5.50933 4.15088Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43402 6.7168H2.64153C1.20755 6.7168 0 7.92435 0 9.35832C0 10.7923 1.20755 11.9998 2.64153 11.9998H9.43402C10.868 11.9998 12.0755 10.7923 12.0755 9.35832C12.0755 7.92435 10.868 6.7168 9.43402 6.7168ZM9.43402 11.2451H6.03777V8.22624H2.64153C1.81133 8.22624 1.13208 8.67907 0.754722 9.13191C0.905666 8.22624 1.66039 7.47152 2.64153 7.47152H9.43402C10.4906 7.47152 11.3208 8.30171 11.3208 9.35832C11.3208 10.4149 10.4906 11.2451 9.43402 11.2451Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPills);
export default __webpack_public_path__ + "static/media/pills.c485df104cb1c93e8d047993b1a80717.svg";
export { ForwardRef as ReactComponent };